
// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('analysis', {
        url: '/analysis',
        parent: 'main',
        abstract: true,
        templateUrl: 'main/analysis/analysis.tpl.html',
        controller: 'MainAnalysisController as vm'

    });
}

// @ngInject
function MainAnalysisController() {
  var vm = this;
}

angular
    .module('main.analysis', ['analysis.api','analysis.reports', 'analysis.pdfTemplate', 'analysis.userReports'])
    .config(stateConfig)
    .controller('MainAnalysisController', MainAnalysisController);
